// extracted by mini-css-extract-plugin
module.exports = {"ageRestrictionMessage":"AgeRestrictionMessage_ageRestrictionMessage__MwgE1","message":"AgeRestrictionMessage_message__m5CM_"};